import { graphql } from '@/gql';
import type { CallerSubscriptionsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginatedCallerSubscriptionTypeResponse } from '@/models/callerPlan';

export const fetchCallerSubscriptions = async ({
  phoneNumber,
  pagination,
}: CallerSubscriptionsQueryVariables): Promise<PaginatedCallerSubscriptionTypeResponse> => {
  const response = await queryExecute({
    query: graphql(`
      query CallerSubscriptions($pagination: PaginationInputType, $phoneNumber: String!) {
        callerSubscriptions(pagination: $pagination, phoneNumber: $phoneNumber) {
          rows {
            id
            callerId
            planName
            nextPlanName
            callerDescription
            nextCallerDescription
            periodStartAt
            periodEndAt
            expectedPeriodEndAt
            isTrial
            isFreeMonthsPlan
            transactionId
            timePlanSuspendPeriodStartDate
            timePlanSuspendPeriodEndDate
            timeZone
            callerSubscriptionChanges {
              id
              callerPlanId
              callerId
              userId
              action
              changes
              origin
              user {
                firstName
                lastName
                role
              }
              createdAt
              updatedAt
            }
          }
          count
        }
      }
    `),
    variables: {
      phoneNumber,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.callerSubscriptions!;
};
